












import Vue from 'vue';
import { mapState } from 'vuex';

export default Vue.extend({
	name: 'NpButton',
	props: {
		type: { type: String, default: 'button' },
	},
	computed: {
		...mapState({
			isLoading: (state: any) => state.isLoading,
		}),
	},
})
